import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mt-4 p-2 bg-white dark:border-gray-800 rounded-md shadow-md" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = { key: 0 }

import { computed } from 'vue';
  import { Info } from '@/types';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'documentInfo',
  props: {
    data: {}
  },
  setup(__props: any) {

  const props = __props;

  const goodDocument = computed(() => {
    return props.data?.cert?.toLowerCase()?.includes('good');
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", null, "Document Type :", -1)),
      _createElementVNode("div", null, [
        (_ctx.data?.cert)
          ? (_openBlock(), _createElementBlock("b", {
              key: 0,
              class: _normalizeClass({
            'text-green-500': goodDocument.value,
          })
            }, [
              _createTextVNode(_toDisplayString(_ctx.data?.cert) + " ", 1),
              (_ctx.data?.cert)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "For export from the USA"))
                : _createCommentVNode("", true)
            ], 2))
          : (_openBlock(), _createElementBlock("b", {
              key: 1,
              class: _normalizeClass({
            'text-red-500': !goodDocument.value,
          })
            }, " Unknown, ask manager ", 2))
      ])
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-sm text-gray-700" }, " Problems with documents may cause additional expenses. For more information, please refer to the work chat. ", -1))
  ]))
}
}

})